import classNames from 'classnames';
import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import AliasField, {BaseAliasFieldProps} from './AliasField';

export interface DraggableAliasFieldProps extends BaseAliasFieldProps {
  id: string;
  isDragging?: boolean;
  onDragStart: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  isEditable: boolean;
}

export function DraggableAliasField(props: DraggableAliasFieldProps): JSX.Element {
  return (
    <div className="simpleDivTable-rowContainer selectorSettings-simpleDivTable-rowContainer">
      <a
        className={classNames('u-primary-pointer simpleDivTable-action simpleDivTable-action--move', {
          faded: !props.isDragging,
          'u-primary-color': props.isDragging,
          invisible: !props.isEditable,
        })}
        onMouseDown={props.onDragStart}
      >
        <BenchlingIcon icon="grip-dots-vertical" />
      </a>
      <div className="selectorSettings-simpleDivTable-row">
        <AliasField {...props} />
      </div>
    </div>
  );
}
